var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header mb-8"},[_vm._v("회원 가입 완료 🙌")]),_c('div',{staticClass:"vertical-line mb-6"}),_vm._m(0),_c('v-btn',{staticClass:"submit mb-4",attrs:{"text":"","outlined":""},on:{"click":function($event){_vm.$router.push(`/regads?${_vm.queryParams}`);
      _vm.pushDataLayer({
        event: 'clickAdRegisterBtn',
        page: 'signupComplete',
        objectSection: 'signupComplete',
        objectType: 'button',
        objectId: 'gotoAdRegister',
        objectName: '광고정보 입력하기',
      });}}},[_vm._v("광고정보 입력하기 >")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-10"},[_vm._v(" 매장에 딱 맞는 체험단 마케팅 컨설팅을 위해 "),_c('br'),_c('span',{staticClass:"font-weight-bold"},[_vm._v("광고 정보를 입력")]),_vm._v("해주세요! "),_c('br'),_c('br'),_vm._v(" 사장님께 필요한 맞춤형 광고를 셋팅할 수 있어요. ")])
}]

export { render, staticRenderFns }